// One formatter for every coach-facing duration so ELO-derived estimates
// never leak as raw decimal hours ("0.7833333333333333h"): minutes under an
// hour, hours + minutes above ("45m", "1h", "1h 30m").
export const formatMinutesDuration = (minutes: number): string => {
  const whole = Math.round(minutes)
  const hours = Math.floor(whole / 60)
  const rest = whole % 60
  if (hours === 0) return `${rest}m`
  if (rest === 0) return `${hours}h`
  return `${hours}h ${rest}m`
}

// Estimates are minute-grained; hour-denominated inputs (card.est, day
// budgets, planned-hour sums) round to the nearest minute before formatting.
export const formatHoursDuration = (hours: number): string =>
  formatMinutesDuration(hours * 60)

/**
 * Compare day budgets here, never on raw hours.
 *
 * Card hours are minutes/60, so most of them are not representable in a
 * double, and a *sum* of them lands a few ULPs off the true total. That is
 * invisible until it meets a strict comparison: 30m + 35m + 25m sums to
 * 1.5000000000000002, so a 1.5h day reads as over budget and turns red while
 * its own label says "1h 30m/1.5h". The other direction is quieter and worse
 * — 20m + 30m + 10m sums to 0.9999999999999999, so a full hour never trips
 * the "exactly full" cue and auto-placement accepts a card that does not fit.
 *
 * Every card's hours came from a whole number of minutes, so the accumulated
 * error is orders of magnitude below half a minute and rounding the total
 * recovers the exact figure.
 */
export const hoursToMinutes = (hours: number): number => Math.round(hours * 60)
